import React, { Fragment, PureComponent } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import NodeImage from "common/NodeImage.js";
import NodeDate from "common/NodeDate.js";
import { imagePropTypes } from "common/Image.js";

export default class PressReleasesNodes extends PureComponent {
	static propTypes = {
		t: PropTypes.func.isRequired,
		nodes: PropTypes.arrayOf(
			PropTypes.shape({
				title: PropTypes.string.isRequired,
				alias: PropTypes.string.isRequired,
				summary: PropTypes.string,
				date: PropTypes.number,
				image: imagePropTypes
			})
		).isRequired
	};
	render() {
		const { t, nodes } = this.props;
		return (
			<Fragment>
				{nodes.map((node, index) => (
					<li key={index}>
						<NavLink to={node.alias}>
							<NodeImage image={node.image} />
							<div className="esa-decor">
								<span className="esa-decorative-line">&nbsp;</span>
								<p>{node.title}</p>
								{node.summary && <div className="summary">{node.summary}</div>}
								<NodeDate t={t} date={node.date} />
							</div>
						</NavLink>
					</li>
				))}
			</Fragment>
		);
	}
}
